import FrameTempleSelect from './FrameTempleSelect'

export * from './FrameTempleSelect'

export default FrameTempleSelect
